import { render, staticRenderFns } from "./DetailVacancy.vue?vue&type=template&id=56b4768a&scoped=true"
import script from "./DetailVacancy.vue?vue&type=script&lang=js"
export * from "./DetailVacancy.vue?vue&type=script&lang=js"
import style0 from "./DetailVacancy.vue?vue&type=style&index=0&id=56b4768a&prod&lang=scss&scoped=true"
import style1 from "./DetailVacancy.vue?vue&type=style&index=1&id=56b4768a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b4768a",
  null
  
)

export default component.exports